import { render, staticRenderFns } from "./AutoApprovalLoadingIndicator.vue?vue&type=template&id=604a6816&scoped=true"
import script from "./AutoApprovalLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./AutoApprovalLoadingIndicator.vue?vue&type=script&lang=ts"
import style0 from "./AutoApprovalLoadingIndicator.vue?vue&type=style&index=0&id=604a6816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a6816",
  null
  
)

export default component.exports